import React from "react";
import {
  Tooltip as RadiaxTooltip,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { HiOutlineInformationCircle, HiOutlineQuestionMarkCircle } from "react-icons/hi2";

type Props = {
  position?: "top" | "right" | "bottom" | "left";
  panelClassName?: string;
  className?: string;
  popoverButton?: React.ReactNode;
  heading?: string;
  symbol?: "question" | "info";
  as?: "button" | "div";
  children?: React.ReactNode;
  delayDuration?: number;
};

const Tooltip = ({
  position = "bottom",
  symbol = "question",
  panelClassName,
  className,
  popoverButton,
  heading,
  as = "button",
  children,
  delayDuration = 700,
}: Props) => {
  const Icon = symbol === "question" ? HiOutlineQuestionMarkCircle : HiOutlineInformationCircle;

  return (
    <TooltipProvider delayDuration={delayDuration}>
      <RadiaxTooltip>
        <TooltipTrigger asChild={as !== "button"} data-testid={"tooltip"} className={className}>
          {popoverButton ?? (
            <div className={"flex items-center"}>
              <Icon className={"h-4.5 w-4.5 text-quinary"} />
            </div>
          )}
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent
            side={position}
            sideOffset={3}
            align={"start"}
            className={clsx(
              "relative z-50 mx-2 flex !max-w-[500px] origin-top flex-col rounded-lg border border-secondary bg-primary p-4 text-left text-sm text-quaternary shadow-sm transition ease-out data-[closed]:scale-95 data-[closed]:opacity-0",
              panelClassName,
            )}
          >
            {heading && <h3 className="mb-2 text-base font-semibold">{heading}</h3>}
            {children}
          </TooltipContent>
        </TooltipPortal>
      </RadiaxTooltip>
    </TooltipProvider>
  );
};

export default Tooltip;
